
export const GetFaviconUrl = (domain: string) => {
    return `https://www.google.com/s2/favicons?sz=50&domain=${domain}`
}